import React from 'react';
import { observer } from 'mobx-react';
import { List } from 'antd';
import {
  RecordFieldFormatter,
  Render,
  VarCharElementType,
} from '@project/store/shared/RecordCard/RecordFieldFormatter';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { RecordCardLink } from './RecordLink';
import { RecordCard } from '@project/store/shared/RecordCard';

import '@assets/scss/index.scss';
import './style.scss';

const render: Render = {
  textRender: (text: string) => text,
  emptyRender: () => '-',
  trueRender: () => <CheckOutlined style={{ color: 'green' }} />,
  falseRender: () => <CloseOutlined style={{ color: 'red' }} />,
  dateRender: (date) => date,
  timeStampRender: (date) => date,
  varCharRender: (data) =>
    data.map((elem, i) => {
      let href: string | undefined;

      if (elem.type === VarCharElementType.url) href = elem.value;

      if (elem.type === VarCharElementType.email) href = `mailto:${elem.value}`;

      if (!href) return <span key={`${elem.value} - ${i}`}>{elem.value}</span>;

      return (
        <a target="_blank" href={href} key={`${elem.value} - ${i}`}>
          {elem.value}
        </a>
      );
    }),
  referencesRender: (tableName: string, recordId: string | number) => (
    <RecordCardLink
      tableName={tableName}
      recordId={recordId}
      options={{ findConnectedLayer: true }}
    />
  ),
};

const formatter = new RecordFieldFormatter(render);

interface FieldsProps {
  card: RecordCard;
}

export const Fields: React.FC<FieldsProps> = observer(function Fields({
  card,
}) {
  const { tableName, recordId, fields } = card;

  return (
    <List size="small">
      {fields.map((field) => {
        const { columnDescription, value, columnName, type, references } =
          field;

        return (
          <List.Item key={`${tableName}-${recordId}-${columnName}`}>
            <List.Item.Meta
              title={
                <span className={'card-field-item-description'}>
                  {columnDescription || columnName}
                </span>
              }
              description={
                <span className={'card-field-item-value'}>
                  {formatter.formatValue(type, value, references)}
                </span>
              }
            />
          </List.Item>
        );
      })}
    </List>
  );
});
